import React from 'react'
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { CSVLink } from "react-csv";
import DownloadImg from "../../assests/download.svg";
import { textAlign } from '@mui/system';
const TableModalBUH = (props) => {
const {open,setshowModal,data}=props
const handleCloseModal=()=>{
    setshowModal(false)
}
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1200,
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    p: 2,
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
  };
  const columns = [
    { field: "id", headerName: "ID", width: 40, hide: true },
    {
      field: "rbmcode",
      headerName: "RBM Code",
      width: 130,
      hide: true
    },
    {
      field: "rbmname",
      headerName: "RBM Name",
      width: 130,
   
    },
    {
      field: "abmcode",
      headerName: "ABM Code",
      width: 130,
      hide: true
   
    },
    {
      field: "abmname",
      headerName: "ABM Name",
      width: 130,
   
    },
    {
      field: "repcode",
      headerName: "REP Code",
      width: 130,
      hide: true
   
    },
    {
      field: "repname",
      headerName: "REP Name",
      width: 130,
   
    },
    {
      field: "brand",
      headerName: "Brand",
      width: 80,
    },
    {
      field: "proddesc",
      headerName: "Product",
      width: 120,
    },
    {
      field: "rci",
      headerName: "Dynamic RCI(%)",
      width: 100,
    },
    { field: "median", headerName: "Median", width: 60,hide: true },
    { field: "maxx", headerName: "Max", width: 60 ,hide: true},
    {
      field: "m1_unadjusted_budget_unit",
      headerName: "Unadj.Budget UN(Jun)",
      width: 100,
    },
    {
      field: "m1_unadjusted_budget_value",
      headerName: "Unadj.Budget Val(Jun)",
      width: 100,
      hide: true
    },
    {
      field: "m1_plus_minus",
      headerName: "Inc/Dec",
      width: 130,
    },

    {
      field: "m1_adjusted_budget_unit",
      headerName: "Adj.Bud.UN(Jun)",
      width: 100,
    },
    {
      field: "m1_adjusted_budget_value",
      headerName: "Adj.Bud.Value(Jun)",
      width: 100,
      
    },
    {
      field: "post_budget_adjustment_m1_rci",
      headerName: "Adj RCI UN(Jun)",
      width: 100,
      hide: true
  
    },
    {
      field: "m2_unadjusted_budget_unit",
      headerName: "Unadj.Budget UN(Jul)",
      width: 100,
    },
    {
      field: "m2_unadjusted_budget_value",
      headerName: "Unadj.Budget VAL(Jul)",
      width: 100,
      hide: true
    },
    {
      field: "m2_plus_minus",
      headerName: "Inc/Dec",
      width: 130,
  
    },
    {
      field: "m2_adjusted_budget_unit",
      headerName: "Adj.Bud.UN(Jul)",
      width: 100,
      
    },
    {
      field: "m2_adjusted_budget_value",
      headerName: "Adj.Bud.Val(Jul)",
      width: 100,
     
    },
    {
      field: "post_budget_adjustment_m2_rci",
      headerName: "Adj RCI UN(Jul)",
      width: 100,
      hide: true
    },
    {
      field: "m3_unadjusted_budget_unit",
      headerName: "Unadj.Budget UN(Aug)",
      width: 100,
    },
    {
      field: "m3_unadjusted_budget_value",
      headerName: "Unadj.Budget Val(Aug)",
      width: 100,
      hide: true
    },
    {
      field: "m3_plus_minus",
      headerName: "Inc/Dec",
      width: 130,
     
    },
    {
      field: "m3_adjusted_budget_unit",
      headerName: "Adj.Bud.UN(Aug)",
      width: 100,
     
    },
    {
      field: "m3_adjusted_budget_value",
      headerName: "Adj.Bud.Val(Aug)",
      width: 100,
  
    },
    {
      field: "post_budget_adjustment_m3_rci",
      headerName: "Adj RCI UN(Aug)",
      width: 100,
      hide: true
    },
    {
      field: "rci_guardrail_check_m1",
      headerName: "Response(Jun)",
      width: 120,
    
    },
    {
      field: "rci_guardrail_check_m2",
      headerName: "Response(Jul)",
      width: 150,
     
    },
    {
      field: "rci_guardrail_check_m3",
      headerName: "Response(Aug)",
      width: 150,
    },
    {
      field: "reason",
      headerName: "Reason*",
      width: 150,
    },
    {
      field: "comment",
      headerName: "Add Comments",
      width: 150,
    }
  ];
  return (
    <div>
         <Modal
          open={open}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div style={{display:"flex",justifyContent:"end"}}>
          <button
            className="download-btn-commercial"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor:"pointer"
              
            }}
          >
            <img
              src={DownloadImg}
              alt=""
              style={{ marginRight: "6px", height: "12px" }}
            />
           <CSVLink data={data} filename={"details.csv"} style={{textDecoration:"none",color:"black"}}>Download</CSVLink>
          </button>
            <CloseIcon
              onClick={handleCloseModal}
              style={{
                marginLeft: "10px",
                color: "white",
                alignSelf: "flex-end",
                backgroundColor:"red",
                padding:"4px",
                borderRadius:"10px"
              }}
            />
            </div>
        <div style={{ height: 500, width: '100%' ,marginLeft:10,marginTop:10,backgroundColor:'#ffff',color:'#ffff'}}>
        
         
          <DataGrid
            rows={data}
            columns={columns}
            density='compact'
            hideFooter={true}
          />
    </div>
          </Box>
        </Modal>
    </div>
  )
}

export default TableModalBUH